import React from "react";
import home from "../../assets/objective.png";
import missionImage1 from "../../assets/mission/mission.jpg";
import missionImage2 from "../../assets/mission/missionimg1.jpg";
import missionImage3 from "../../assets/mission/missionimg2.jpg";
import mission2 from "../../assets/image2.png";
import facility from "../../assets/facility.png";
import disease from "../../assets/disease.png";
import work from "../../assets/work.png";
import ContactForm from "../../common/ContactForm/Contact";
import StoriesOfImpact from "../../common/Story/Story";
import Donate from "../../common/Donation/Donate";
import DonateToFood from "../../common/DonateToFood/DonateFood";
import Quote from "../../common/Quote/Quote";
import HeaderSection from "../../common/HeaderSection/Header";
import "./Mission.css";
import { useNavigate } from "react-router-dom";
import CarouselPage from "../../common/Carousel/CarouselPage";

function Mission() {
  const navigate = useNavigate();
   const carouselImages = [
          { src: missionImage1, alt: "First image ",style: { height: "600px", width: "100%", objectFit: "cover" } },
          { src: missionImage2, alt: "Second image",style: { height: "600px", width: "100%", objectFit: "cover" } },
          { src: missionImage3, alt: "Third image" ,style: { height: "600px", width: "100%", objectFit: "cover" }},
        ];
  return (
    <>
   <CarouselPage images={carouselImages} />
      <HeaderSection 
        image={missionImage1}
        imageStyle={{marginTop: "3rem"}}
        text="OUR Mission"
        className="home-image"
        longtext="“ EMPOWERING EDUCATIONAL COMMUNITY  “"
      />
      <div className="hero-section">
        <div className="hero-message">
          <p>
            We believe that, as a communicator in the form of a non-profit
            organization, our role is{" "}
            <span>to help amplify the voices of underprivileged people.</span>{" "}
            We aim to provide a platform for them to share their stories in a
            way that feels authentic and empowering, enabling us to better
            understand their experiences and offer meaningful support. 
          </p>
          <div>
            <p>
              We recognize the challenge of fully comprehending the lives of
              those who endure poverty and hardship. For many, the concept of
              dreaming has faded, replaced by a daily acceptance of life as it
              is. This reality raises questions about the potential for
              change—but{" "}
              <span>
                we are committed to seeking ways to make a difference.
              </span>{" "}
              The painful reality is that each day, lives are lost to
              circumstances that could have been prevented. 
            </p>
          </div>
          <div>
            <p>
              Our mission is{" "}
              <span>
                to offer both formal and non-formal education across various
                levels, from primary schooling to higher education,
              </span>{" "}
              through schools, colleges, research centers, and teacher training
              institutions. By empowering individuals through education, we
              aspire to bring hope and transformative change to communities in
              need. 
            </p>
          </div>
        </div>
        <Quote text="“ Vibrant living where faith, wellness and community flourish ”" />

        <div className="objectives">
          <h2>Objectives & Functions</h2>
          <div className="objectives-message">
            <img src={home} alt="objectives functions" />
            <p>
              <span>
                The main aims and objectives for which the society was
                established are as follows:
              </span>{" "}
              to establish centers for digital and artificial intelligence,
              machine learning, data science, and biometric studies in local,
              urban, and remote areas; to establish boarding schools for both
              technical and general academic purposes; to create knowledge and
              art exchange centers for India as well as foreign countries; to
              establish colleges and centers for paramedical sciences, medical
              studies, ayurvedic and Unani medicine, and herbal practices; to
              establish ITI, diploma, degree, postgraduate, and research centers
              for engineering and biomedical sciences; to create centers that
              promote local industries and crafts globally, such as textiles,
              traditional arts, and crafts; and to establish, oversee, organize,
              operate, maintain, and manage various institutions, including
              schools, colleges, hospitals, dispensaries, physiotherapy centers,
              pharmacies, herbal product centers, call centers, multimedia
              centers, agricultural training centers, skill development courses,
              yoga and meditation centers, and vocational training centers. 
            </p>
          </div>
        </div>
        <div className="our-mission">
          <div className="mission-message">
            <h1>Our Mission</h1>
            <p>
              To promote education, vocational training, music, and the
              diffusion of useful knowledge; to provide medical relief,
              industrial training, and charitable support, including all aspects
              of rural reconstruction and social welfare projects, irrespective
              of race, caste, community, or creed. To engage in social welfare
              activities aimed at improving the living conditions and general
              well-being of poor and indigent individuals, regardless of their
              occupation, race, caste, community, or creed. To establish and
              maintain libraries and reading rooms, equipping them with
              necessary supplies such as books, newspapers, periodicals,
              furniture, and audio-visual aids. 
            </p>
          </div>
          <div className="mission-pledge">
            <h1>
              Take A 
              Pledge!
            </h1>
            <button className="support" onClick={() => navigate('/donate-form')}>Support Us</button>
          </div>
        </div>
        <div className="society-mission">
          <p>
            The society’s mission extends to social welfare, including the
            establishment of old age homes, homes for differently-abled
            individuals, and support facilities for women, children, and the
            underprivileged. It promotes cultural exchange and preservation by
            encouraging traditional Indian arts, music, and handicrafts, while
            also honoring individuals excelling in these fields. Additionally,
            it aims to engage in environmental conservation by promoting
            activities such as reforestation, waste management, and the use of
            renewable energy. Finally, the society’s framework emphasizes
            inclusivity, with all its activities being non-profit and dedicated
            to public welfare, ensuring that no member profits from its assets
            or resources. 
          </p>
          <img src={mission2} alt="society mission" />
        </div>
        <div className="galleryfood">
        <DonateToFood />
        </div>
        <div className="facility">
          <div className="facility-content">
            <h1>
              How We're Making A 
              Difference
            </h1>
            <p>
              Our society will facilitate sports and recreational facilities,
              community halls, and public conveniences, as well as encourage
              legal assistance for the poor. It will conduct activities like
              free coaching for competitive exams, sponsor students for
              international education, and grant scholarships.
            </p>
            <div className="facility-item">
              <img className="icon" src={disease} alt="disease" />
              <p>To fight against HIV/AIDS and other communicable diseases.</p>
            </div>
            <div className="facility-item">
              <img className="icon" src={work} alt="working professional" />
              <p>
                To work for environmental protection, forestation plantation,
                waste land, management, rainwater harvesting, Electrical &
                Electronic, solar energy plant.
              </p>
            </div>
            <button className="learn-more">Learn More</button>
          </div>
          <div className="facility-image">
            <img src={facility} alt="Making a Difference" />
          </div>
        </div>
      </div>

      <Donate
        text="We cannot help everyone but
            everyone <br />
            can help"
      />
      <StoriesOfImpact />
      <ContactForm />
    </>
  );
}

export default Mission;
